import { render, staticRenderFns } from "./svgTiktok.vue?vue&type=template&id=04dc4938&scoped=true"
import script from "./svgTiktok.vue?vue&type=script&lang=js"
export * from "./svgTiktok.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dc4938",
  null
  
)

export default component.exports